export default __webpack_public_path__ + "static/media/odt.f4d98d88.svg";